export default {
  // Navbar
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.solutions': 'Solutions',
  'nav.process': 'Process',
  'nav.benefits': 'Benefits',
  'nav.contact': 'Contact',
  'nav.getStarted': 'Get Started',

  // Hero Section
  'hero.title': 'Automation Consulting Excellence',
  'hero.subtitle': 'Transform Your Operations Through Intelligent Automation',
  'hero.description': 'We specialize in delivering tailored IT solutions for Healthcare, Education, Retail & Service industries—solving real operational challenges with measurable results.',
  'hero.consultation': 'Schedule a Consultation',
  'hero.ourSolutions': 'Our Solutions',

  // About Section
  'about.title': 'About Us',
  'about.subtitle': 'Your Trusted Partner in Automation',
  'about.description1': 'Global Pillar Limited was established in 2022 in Hong Kong. Over these years, we have accumulated profound professional and technical expertise to serve diverse industries. We specialize in delivering customized IT solutions tailored to our clients\' unique requirements through a structured process of discovery, design, development, and testing.',
  'about.description2': 'As pioneers in mobile application development amid the rise of smartphones, we continue to integrate advanced technologies to elevate service quality and efficiency. Our comprehensive solutions empower businesses to operate seamlessly while maintaining affordable IT budgets.',
  'about.stat1': 'Projects Completed',
  'about.stat2': 'Industries Served',
  'about.stat3': 'Client Satisfaction',
  'about.stat4': 'Support Available',

  // Solutions Section
  'solutions.title': 'Our Solutions',
  'solutions.subtitle': 'Industry-Specialized Automation Consulting',
  'solutions.healthcare': 'Healthcare',
  'solutions.education': 'Education',
  'solutions.retail': 'Retail & Service',
  'solutions.learnMore': 'Learn More',
  'solutions.showLess': 'Show Less',
  'solutions.scheduleConsultation': 'Schedule a Consultation',

  // Healthcare
  'healthcare.desc': 'Compliant, efficient automation solutions for medical institutions',
  'healthcare.pain1.title': 'Fragmented Patient Records',
  'healthcare.pain1.challenge': 'Multiple systems create data silos, duplicate entries, and potential errors',
  'healthcare.pain1.solution': 'Our Consulting Approach: Implement unified Electronic Health Record (EHR) systems that integrate all patient data for instant access and updates',
  'healthcare.pain1.result': '70% reduction in record retrieval time, 40% improvement in data accuracy',
  'healthcare.pain2.title': 'Manual Appointment Scheduling',
  'healthcare.pain2.challenge': 'Phone-based bookings lead to double-bookings, long wait times, and administrative burden',
  'healthcare.pain2.solution': 'Our Consulting Approach: Deploy intelligent scheduling systems with automated reminders, online booking, and resource optimization',
  'healthcare.pain2.result': '60% decrease in no-shows, 50% reduction in administrative workload',
  'healthcare.pain3.title': 'Compliance Reporting Burden',
  'healthcare.pain3.challenge': 'Manual tracking of regulatory requirements is time-consuming and error-prone',
  'healthcare.pain3.solution': 'Our Consulting Approach: Automated compliance monitoring and reporting systems with built-in audit trails and real-time alerts',
  'healthcare.pain3.result': '80% faster compliance reporting, 100% improvement in audit readiness',

  // Education
  'education.desc': 'Modern, interactive digital solutions for educational institutions',
  'education.pain1.title': 'Disconnected Systems',
  'education.pain1.challenge': 'Student information, grades, and communication scattered across multiple platforms',
  'education.pain1.solution': 'Our Consulting Approach: Integrated Learning Management Systems (LMS) that unify student data, grades, and parent communication',
  'education.pain1.result': '65% increase in administrative efficiency, 45% boost in parent engagement',
  'education.pain2.title': 'Limited Engagement Tracking',
  'education.pain2.challenge': 'Difficulty monitoring student progress and identifying those needing support',
  'education.pain2.solution': 'Our Consulting Approach: Analytics-driven tracking systems providing real-time insights into student performance and engagement',
  'education.pain2.result': '55% improvement in early intervention, 35% increase in student outcomes',
  'education.pain3.title': 'Manual Fee Collection',
  'education.pain3.challenge': 'Paper invoices and cash handling lead to delays and reconciliation issues',
  'education.pain3.solution': 'Our Consulting Approach: Digital payment systems with automated invoicing, reminders, and online payment options',
  'education.pain3.result': '75% increase in on-time payments, 40% reduction in administrative costs',

  // Retail & Service
  'retail.desc': 'Drive growth in retail and service industries through smart automation',
  'retail.pain1.title': 'Inventory Discrepancies',
  'retail.pain1.challenge': 'Manual inventory tracking leads to stockouts, overstock, and lost revenue',
  'retail.pain1.solution': 'Our Consulting Approach: Real-time inventory management systems with automated reordering and predictive analytics',
  'retail.pain1.result': '60% reduction in stockouts, 35% decrease in inventory costs',
  'retail.pain2.title': 'Fragmented Customer Data',
  'retail.pain2.challenge': 'Customer information scattered across POS, online, and loyalty programs',
  'retail.pain2.solution': 'Our Consulting Approach: Unified CRM systems integrating all touchpoints for personalized marketing and service',
  'retail.pain2.result': '50% improvement in customer retention, 40% increase in repeat purchases',
  'retail.pain3.title': 'Manual Processes',
  'retail.pain3.challenge': 'Manual tasks from order processing to reporting consume valuable time',
  'retail.pain3.solution': 'Our Consulting Approach: End-to-end process automation from order to fulfillment to financial reporting',
  'retail.pain3.result': '70% faster processing times, 55% boost in operational efficiency',

  // Process Section
  'process.title': 'Our Consulting Process',
  'process.subtitle': 'A Client-Centric Approach to Ensure Perfect Fit',
  'process.step1.title': 'Discovery',
  'process.step1.desc': 'Understanding your business needs and challenges',
  'process.step2.title': 'Design',
  'process.step2.desc': 'Crafting intuitive, scalable architectures',
  'process.step3.title': 'Development',
  'process.step3.desc': 'Building with the latest technologies for reliability and performance',
  'process.step4.title': 'Testing',
  'process.step4.desc': 'Rigorous quality assurance to deliver bug-free, high-performing products',

  // Benefits Section
  'benefits.title': 'Why Choose Us',
  'benefits.subtitle': 'Your Advantage for Success',
  'benefits.affordable.title': 'Affordable IT Budgets',
  'benefits.affordable.desc': 'Our solutions minimize long-term costs by optimizing workflows and reducing manual efforts.',
  'benefits.efficiency.title': 'Enhanced Efficiency',
  'benefits.efficiency.desc': 'Integrate advanced tech to automate processes and improve service quality.',
  'benefits.specialized.title': 'Industry-Specialized Consultants',
  'benefits.specialized.desc': 'Whether in healthcare for secure data handling, education for interactive tools, or retail for smart systems, we customize to your sector\'s demands.',
  'benefits.expertise.title': 'Proven Expertise',
  'benefits.expertise.desc': 'Backed by years of experience serving Hong Kong\'s dynamic market, we deliver reliable results.',
  'benefits.roi.title': 'Measurable ROI',
  'benefits.roi.desc': 'Our consulting approach focuses on quantifiable outcomes—40-80% efficiency gains, 35-70% cost reductions.',
  'benefits.partnership.title': 'End-to-End Partnership',
  'benefits.partnership.desc': 'From initial consultation to post-implementation support, we\'re with you every step of the way.',

  // Contact Section
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Ready to Transform Your Business?',
  'contact.description': 'Contact us today for a free consultation. Let\'s build solutions that propel your success!',
  'contact.form.name': 'Your Name',
  'contact.form.email': 'Your Email',
  'contact.form.company': 'Company Name',
  'contact.form.industry': 'Industry',
  'contact.form.industryPlaceholder': 'Select your industry',
  'contact.form.healthcare': 'Healthcare',
  'contact.form.education': 'Education',
  'contact.form.retail': 'Retail & Service',
  'contact.form.other': 'Other',
  'contact.form.message': 'Your Message',
  'contact.form.messagePlaceholder': 'Tell us about your needs...',
  'contact.form.submit': 'Send Message',
  'contact.form.sending': 'Sending...',
  'contact.form.success': 'Thank you! We\'ll get back to you soon.',
  'contact.form.error': 'Failed to send. Please try again.',
  'contact.email': 'Send Email',
  'contact.directEmail': 'Or email us directly at',

  // Footer
  'footer.tagline': 'Transform Your Operations Through Intelligent Automation',
  'footer.quickLinks': 'Quick Links',
  'footer.newsletter': 'Newsletter',
  'footer.newsletterDesc': 'Get the latest automation trends and industry insights',
  'footer.emailPlaceholder': 'Enter your email',
  'footer.subscribe': 'Subscribe',
  'footer.subscribing': 'Subscribing...',
  'footer.subscribeSuccess': 'Thank you for subscribing!',
  'footer.subscribeError': 'Failed to subscribe. Please try again.',
  'footer.rights': 'All rights reserved',
  'footer.poweredBy': 'Powered by Readdy',
};